import { ETagsActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const removeAllTags = actionGenerator<ETagsActionType.RemoveAllTags>(ETagsActionType.RemoveAllTags);
